import { render, staticRenderFns } from "./paymentDialog.vue?vue&type=template&id=bbd0a7be&scoped=true"
import script from "./paymentDialog.vue?vue&type=script&lang=js"
export * from "./paymentDialog.vue?vue&type=script&lang=js"
import style0 from "./paymentDialog.vue?vue&type=style&index=0&id=bbd0a7be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd0a7be",
  null
  
)

export default component.exports